const Constant = {
  TOKEN: "token",
  REFRESH_TOKEN:"rfTk",
  UUID: "uuid",
  MY_WEB: "www.nklotto.com"
}

export {
  Constant
}